import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        mainColor: "#14384d",
        titleSuccess: "#1ABC9C",
        titleInfo: "#5499C7",
        titleWarning: "#F8C471",
        titleDanger: "#E74C3C",
        btnCancel: "#E0E0E0",
        btnSubmit: "#607D8B",
        grayColor: "#3f3f40",
        yellowColor: "#ffcb30",
        taroColor: "#7c76a8",
        blueColor: "#1e4b94",
      },
    },
  },
});
